import { Component, OnInit } from '@angular/core';
import { DataQueryDto } from '../../shared/dto/data-query.dto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { UserService } from 'src/app/users/shared/user.service';
import { ReportService } from '../../shared/report-service';
import { NotificationService, TranslationService } from 'src/app/shared';
import { DuplicateCheckDto } from '../../shared/dto/duplicate-check-dto';

@Component({
  selector: 'wl-query-tool-save-query-modal',
  templateUrl: './query-tool-save-query-modal.component.html',
  styleUrls: ['./query-tool-save-query-modal.component.less'],
    standalone: false
})
export class QueryToolSaveQueryModalComponent implements OnInit {
  activeUsers: SelectItem[] = [];
  show: boolean = false;
  isSaving: boolean = false;
  dataQueryDto: DataQueryDto = {} as DataQueryDto;
  duplicateCheckDto: DuplicateCheckDto = {} as DuplicateCheckDto;
  isEditing: boolean = false;
  constructor(
    private _userService: UserService,
    private _reportService: ReportService,
    private _confirmationService: ConfirmationService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.getActiveUsers();
  }

  showDialog(dataQuery: DataQueryDto) {
    this.show = true;
    this.dataQueryDto = dataQuery;
  }

  checkForDuplicateDataQuery() {
    this.duplicateCheckDto.Name = this.dataQueryDto.Name;
    this._reportService.duplicateQueryCheck(this.duplicateCheckDto).then((result: number) => {
      this.dataQueryDto.Id = result;
      if (result != 0) {
        this._confirmationService.confirm({
          message: this._translationService.getInstantCapitalizeFirstCharacter('reports.query-tool.save-query.overwrite-query-message'),
          key: 'queryOverWriteCD',
          accept: () => {
            this.isEditing = true;
            this.save();
          },
          reject: () => {
            this._confirmationService.close();
          },
        });
      } else {
        this.isEditing = false;
        this.save();
      }
    });
  }

  close() {
    this.show = false;
  }

  private save() {
    if (!this.dataQueryDto.UserNum) {
      this.dataQueryDto.UserNum = 0;
    }

    this.isSaving = true;
    let crudPromise: Promise<void>;
    if (this.isEditing) {
      crudPromise = this._reportService.updateDataQuery(this.dataQueryDto);
    } else {
      crudPromise = this._reportService.createDataQuery(this.dataQueryDto);
    }

    crudPromise
      .then(() => {
        this._notificationService.translateSuccess('common.saved-successfully');
        this.close();
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => (this.isSaving = false));
  }

  private getActiveUsers() {
    this._userService.getActiveUsers().then((data) => {
      if (data.length > 0) {
        this.activeUsers = data.map<SelectItem>((x) => {
          return { label: x.UserName, value: x.UserNum };
        });
        this.activeUsers.sort((a, b) => a.label.localeCompare(b.label));
      }
    });
  }
}
